var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:close-fill",
    clipPath: "url(#clip0_1_2042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99983 11.7679L14.419 16.1871C14.6535 16.4216 14.9715 16.5533 15.3032 16.5533C15.6348 16.5533 15.9528 16.4216 16.1873 16.1871C16.4218 15.9526 16.5536 15.6346 16.5536 15.3029C16.5536 14.9713 16.4218 14.6533 16.1873 14.4188L11.7665 9.9996L16.1865 5.58044C16.3026 5.46433 16.3946 5.32649 16.4574 5.17481C16.5202 5.02312 16.5525 4.86056 16.5524 4.69639C16.5524 4.53223 16.52 4.36967 16.4572 4.21802C16.3943 4.06636 16.3022 3.92858 16.1861 3.81252C16.07 3.69646 15.9321 3.60441 15.7805 3.54163C15.6288 3.47884 15.4662 3.44654 15.302 3.44658C15.1379 3.44662 14.9753 3.47899 14.8237 3.54185C14.672 3.60471 14.5342 3.69683 14.4182 3.81294L9.99983 8.2321L5.58067 3.81294C5.46541 3.6935 5.32753 3.5982 5.17505 3.53262C5.02258 3.46704 4.85857 3.43248 4.6926 3.43096C4.52663 3.42944 4.36201 3.46099 4.20836 3.52377C4.05471 3.58655 3.91511 3.6793 3.79769 3.79661C3.68026 3.91392 3.58738 4.05344 3.52446 4.20703C3.46154 4.36062 3.42983 4.5252 3.43119 4.69118C3.43256 4.85715 3.46696 5.02119 3.5324 5.17373C3.59784 5.32626 3.693 5.46424 3.81233 5.5796L8.23317 9.9996L3.81317 14.4196C3.69383 14.535 3.59867 14.6729 3.53323 14.8255C3.4678 14.978 3.43339 15.1421 3.43203 15.308C3.43066 15.474 3.46237 15.6386 3.52529 15.7922C3.58822 15.9458 3.6811 16.0853 3.79852 16.2026C3.91594 16.3199 4.05555 16.4127 4.2092 16.4754C4.36285 16.5382 4.52746 16.5698 4.69343 16.5682C4.85941 16.5667 5.02341 16.5322 5.17589 16.4666C5.32836 16.401 5.46625 16.3057 5.5815 16.1863L9.99983 11.7679Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.a35c816dab128358583899be6a041a0e.svg";
export { ForwardRef as ReactComponent };